import {combineReducers} from 'redux';
import tickerReducer from './tickerReducer';
import balanceReducer from "./balanceReducer";
import ordersReducer from "./ordersReducer";
import settingsReducer from "./settingsReducer";
import graphSettingsReducer from "./settingsGraphReducer";
import graphReducer from "./graphReducer";
import profitReducer from "./profitReducer";

export default combineReducers({
    ticker: tickerReducer,
    balance: balanceReducer,
    orders: ordersReducer,
    settings: settingsReducer,
    graphSettings: graphSettingsReducer,
    graph: graphReducer,
    profit: profitReducer,
});
